<template>
  <ol class="onboarding-steps">
    <li
      v-for="(step, index) in STEPS"
      :key="step.title"
      class="onboarding-steps__step"
      :class="{ 'onboarding-steps__step--current': index + 1 === props.currentStep, 'onboarding-steps__step--done': index + 1 < props.currentStep }"
      :aria-current="index + 1 === props.currentStep ? 'step' : undefined"
    >
      <span class="onboarding-steps__number">
        <IconEmbedded v-if="index + 1 < props.currentStep" name="check_3" :size="14" color="currentColor" />
        <template v-else>{{ index + 1 }}</template>
      </span>
      <div class="onboarding-steps__copy">
        <div class="onboarding-steps__title">{{ step.title }}</div>
        <div class="onboarding-steps__subtitle">{{ step.subtitle }}</div>
      </div>
    </li>
  </ol>
</template>

<script setup lang="ts">
import IconEmbedded from "@components/ui/IconEmbedded.vue";

// Shared by the Atlas onboarding pages so the three steps read the same on each of them.
const STEPS = [
  { title: "Review what we found", subtitle: "Confirm the places and events you'd like to highlight." },
  { title: "Add your photos", subtitle: "Bring your destination to life with photos you already have." },
  { title: "Create social posts", subtitle: "We'll turn your photos into posts for you to review." },
];

const props = defineProps<{
  /** 1-based. */
  currentStep: number;
}>();
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

// Onboarding steps ===========================================================
.onboarding-steps {
  margin: 0;
  padding: 20px 22px;
  gap: 24px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  background: #f5f7f8;
  list-style: none;

  &__step {
    gap: 12px;
    display: flex;
    align-items: flex-start;
  }

  &__number {
    width: 28px;
    height: 28px;
    flex: 0 0 28px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #d0d5dd;
    border-radius: 50%;
    background: #fff;
    color: #667085;
    font: 600 13px/1 sans-serif;
  }

  &__title {
    color: #101828;
    font: 600 14px/19px $font-family;
  }

  &__subtitle {
    margin-top: 3px;
    color: #667085;
    font: 400 13px/18px sans-serif;
  }

  &__step--current &__number,
  &__step--done &__number {
    border-color: #058587;
    background: #058587;
    color: #fff;
  }

  &__step--current &__title {
    color: #058587;
  }
}

// tablet and below -------------------
@media (max-width: $tablet-max-width) {
  .onboarding-steps {
    gap: 14px;
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
